<template>
  <div class="container" id="ResetPassword">
    <div class="row navbar-uli justify-content-between">
      <div class="col-6 text-left">
        <a href="/login">
          <i class="fas fa-chevron-left"></i>
        </a>
      </div>
      <div class="col-6 text-right"></div>
    </div>
    <div class="row justify-content-center total-login">
      <div class="col-12">
        <h1>Resetar senha</h1>
      </div>
      <div class="col-12">
        <p>Digite a nova senha</p>
      </div>
      <form novalidate="true">
        <div class="col-12 mt-4">
          <input v-model="userData.password" :type="showPassword ? 'text' : 'password'">
          <img
            @click="passwordReveal"
            v-if="!showPassword"
            class="password-icon"
            src="../../assets/img/eye-regular.svg"
            alt
          >
          <img
            @click="passwordReveal"
            v-else
            class="password-icon"
            src="../../assets/img/eye-slash-regular.svg"
            alt
          >
        </div>
        <div class="col-12 my-2" v-if="errorPassword">
          <p>Senha muito curta</p>
        </div>
        <div class="col-12 mt-4">
          <button @click.prevent="handleForm" class="btn btn-primario btn-large">Salvar senha</button>
        </div>
      </form>
      <div class="col-12 mt-4" v-if="returnAxios">
        <p>{{responseMessage}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ResetPassword",
  data() {
    return {
      showPassword: false,
      userData: {
        password: "",
        hash: ""
      },
      errorPassword: false,
      responseMessage: "Senha alterada com sucesso. Redirecionando para login.",
      returnAxios: false,
      ROOT_API: null
    };
  },
  methods: {
    passwordReveal,
    getHash,
    handleForm
  },
  created() {
    this.ROOT_API = process.env.ROOT_API;
    this.getHash();
  }
};
function passwordReveal() {
  this.showPassword = !this.showPassword;
}
function getHash() {
  let urlHash = window.location.href.split("=");
  this.userData.hash = urlHash[1];
}
function handleForm() {
  this.errorPassword = false;
  if (this.userData.password.length < 6) {
    this.errorPassword = true;
  } else {
    let totalData = this.userData;
    axios({
      method: "post",
      url: this.ROOT_API + "api/password/reset",
      data: totalData,
      config: { headers: { "Content-Type": "multipart/form-data" } }
    }).then(response => {
      if (response.data.status == 0) {
        this.responseMessage = response.data.error;
      } else {
        setTimeout(() => {
          this.$router.push("/login");
        }, 3000);
      }
      console.log(response);
      this.returnAxios = true;
    });
  }
}
</script>

<style scoped>
.navbar-uli {
  padding-top: 11px;
  margin-bottom: 10px;
}
.navbar-uli a {
  color: #000;
  font-size: 16px;
}
.navbar-uli a:hover {
  text-decoration: none;
}
.logo-uli img {
  height: 118px;
  margin-top: 14px;
  margin-bottom: 20px;
}
.total-login {
  margin-top: 24px;
}
.total-login h1 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}
.total-login p {
  color: #777777;
  margin-bottom: 0;
}
form {
  width: 80%;
  max-width: 345px;
}
input[type="password"],
input[type="text"] {
  margin: 0 0 18px 0;
  font-size: 16px;
  font-family: "Montserrat", sans-serif;
  padding: 6px 0 0 0;
}
input[type="password"],
input[type="text"] {
  padding-right: 30px;
}
input[type="password"]::placeholder,
input[type="text"]::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #000;
  font-size: 16px;
  opacity: 1; /* Firefox */
}

input[type="password"]:-ms-input-placeholder,
input[type="text"]:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #000;
  font-size: 16px;
}

input[type="password"]::-ms-input-placeholder,
input[type="text"]::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #000;
  font-size: 16px;
}
.password-icon {
  height: 16px;
  position: absolute;
  right: 20px;
  top: 9px;
}
.password-icon:hover {
  cursor: pointer;
}
.link-login {
  color: #6828e8;
}
.link-login:hover {
  text-decoration: none;
}
</style>




// WEBPACK FOOTER //
// src/components/templates/ResetPassword.vue